import React from 'react';
import PropTypes from 'prop-types';

import CSSModules from 'react-css-modules';
import { injectConfig, configShape } from '@client/hoc/config';
import {
    XMAS_EVENT_DELIVERY_PROMISE,
    XMAS_BANNER_LOCATION
} from '@client/config/constants';
import SpecialBanner from '@client/components/shared/SpecialBanner';
import DeliveryDate from './DeliveryDate';
import DeliveryLabel from './DeliveryLabel';
import CampaignInfo from './CampaignInfo';
import CategorySubline from './category-subline';


import styles from './campaignLabel.scss';

/* eslint-disable react/no-did-mount-set-state */
export function CampaignLabel({ dimension, discount, campaign, showDelivery, hover, config, categorySubline }) {
    const specificDeliveryTimeText = config.isEnabled('shortDeliveryText') ? 'campaigns.specificDeliveryTime' : null;
    const isSpecialDeliveryBanner = campaign && campaign.options && campaign.options.deliveryPromiseType === XMAS_EVENT_DELIVERY_PROMISE;

    return (
        <div styleName="wrapper">
            {(campaign.options && campaign.options.deliveryPromiseType && !campaign.options.shortenDelivery) && !isSpecialDeliveryBanner &&
                <DeliveryLabel
                    message={campaign.bannerSpecialText}
                    hover={hover}
                />
            }
            {(campaign.options && campaign.options.shortenDelivery) &&
                <DeliveryLabel
                    message={campaign.bannerSpecialText}
                    translationId={specificDeliveryTimeText}
                    hover={hover}
                />
            }
            {isSpecialDeliveryBanner &&
                <SpecialBanner location={XMAS_BANNER_LOCATION.isMylounge} />
            }
            {showDelivery &&
                <DeliveryDate {...campaign} />
            }
            <div styleName="title">
                <span styleName="campaign-name">{campaign.name}</span>
                {categorySubline && (
                    <span styleName="category-subline">
                        <CategorySubline categorySubline={categorySubline} />
                    </span>
                )}
            </div>
            <CampaignInfo dimension={dimension} discount={discount} campaign={campaign} />
        </div>
    );
}

CampaignLabel.propTypes = {
    discount: PropTypes.string.isRequired,
    dimension: PropTypes.string.isRequired,
    hover: PropTypes.bool,
    campaign: PropTypes.object.isRequired,
    showDelivery: PropTypes.bool,
    categorySubline: PropTypes.arrayOf(PropTypes.string),
    config: configShape
};

export default injectConfig(CSSModules(CampaignLabel, styles, { allowMultiple: true }));
